module.exports = __webpack_public_path__ + "4e66e142e1d3ecb06801f744d0dc35d8.MP3";